import { Component, computed, DestroyRef, effect, inject, signal, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { DataService } from 'src/app/services/data.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { IBudgetantrag } from 'src/app/types/IBudgetantrag';
import { GridService } from 'src/app/services/controls/grid.service';
import { Pages } from 'src/app/types/infrastructure/enums/Pages';
import { AppstateService } from 'src/app/services/appstate.service';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';

@Component({
  selector: 'app-budget-archiv-liste',
  templateUrl: './budget-archiv-liste.component.html',
  styleUrl: './budget-archiv-liste.component.css'
})
export class BudgetArchivListeComponent {

  @ViewChild(DxDataGridComponent, { static: false })
  public dataGrid!: DxDataGridComponent;
  public budgetantraege = computed<IBudgetantrag[]>(() => this.dataService.budgetantraege());
  public infoText = computed(() => ((this.gridService.FilterTextNavigationArchiv() + this.gridFilterText()) ? 'Filterung nach ' + this.gridService.FilterTextNavigationArchiv() + this.gridFilterText() : ''))
  public gridFilterText = signal('');
  public dataCountText = signal('');
  public showFilterRow = signal(false);
  public showHeaderFilter = signal(true);

  constructor(public appStateService: AppstateService,
              private navigationService: NavigationService,
              public gridService: GridService,
              private dataService: DataService) {

    effect(() => {
      if (this.budgetantraege() == null) {
        this.dataGrid.instance.beginCustomLoading("Budgetanträge werden geladen...");
      } else {
        this.dataGrid.instance.endCustomLoading();
      }
    });
  }
  
  
  private readonly destroyRef = inject(DestroyRef);
  
    ngAfterViewInit(): void {
      this.destroyRef.onDestroy(() => {
        // Seite/Component wird verlassen -> Grid-State sichern
        this.gridService.saveGridState(this.dataGrid, this.appStateService.gridStateArchiv);
      });
    }

    onGridInitialized(e: any) {
      // Restore saved grid state as early as possible (columns order/width + filter)
     this.gridService.loadGridState(this.dataGrid, this.appStateService.gridStateArchiv);
  }

  onContentReady(e: any) {
    if (e.component.getCombinedFilter() != null) {
      if (this.gridService.FilterTextNavigationArchiv()) {
        this.gridFilterText.set(' | manueller Eingabe');
      } else {
        this.gridFilterText.set('manueller Eingabe');
      }
    } else {
      this.gridFilterText.set('');
    }
      
    this.dataCountText.set(e.component.totalCount() + ' Projekte');
  }

  onBudgetantragButtonClick(e: any) {
    if (e.row.rowType === "data") {
      this.navigationService.navigateToBudgetantragDashboard(e.row.data.projektID, e.row.data.budgetantragID, Pages.ARCHIVLISTE);
    }
  }

  onDataGridRowDblClick(e: any) {
    if (e.rowType === "data") {
      this.navigationService.navigateToBudgetantragDashboard(e.data.projektID, e.data.budgetantragID, Pages.ARCHIVLISTE);
    }
  }

  onHeaderFilterButtonClick() {
    this.dataGrid.instance.clearFilter();
  }

  async onGridExporting(e: DxDataGridTypes.ExportingEvent) {
			var filename = 'Budgetantrag-Archivliste ' + new Date().toLocaleDateString() + '.xlsx';
			await this.gridService.exportDxGridToExcel(e.component, {
				worksheetName: 'Budgetantrag-Archivliste ',
				fileName: filename,
				includeHiddenColumns: false,
				includeHiddenBands: false
			});
			e.cancel = true;
		}

}
